<template>
  <mu-card>
      <mu-card-header
        titleClass="blueTitle largeTitle"
        :title="$t('message.lessonQuestionsTitle')"
        :subTitle="$t('message.lessonQuestionsSubTitle')"
        class="noPaddingRight"
      >
      </mu-card-header>
    <mu-circular-progress v-if="changeData" :size="40"/>

    <div v-if="!changeData">
        <mu-list>
          <mu-list-item
            v-for="question, index in data.questions"
            v-if="hasQuestions"
            :key="'question-index-' +  index"
            @click.native="goToQuestion(question.question_id)"
          >
            <mu-avatar
              v-if="!question.profile_large"
              slot="left"
              color="#0179d5"
              backgroundColor="#E9E9E8">
              {{upperTwoInitials(question.display_name)}}
            </mu-avatar>
            <mu-avatar
              v-else
              :src="question.profile_large"
              slot="left"
              color="white"
              backgroundColor="#E9E9E8"
            >
            </mu-avatar>
            <div slot="title" v-html="$sanitize(question.question)"></div>
            <span slot="describe">
              <span
                style="color: rgba(0, 0, 0, .87)"
                v-text="question.display_name">
              </span>
                &middot;
              <span v-text="formatDate(question.timestamp)"></span>
                <span v-if="question.replies !== 0">
                  &middot;
                  <span v-text="question.replies +  (question.replies > 1 ? ' replies' : ' reply')"></span>
                </span>
            </span>
          </mu-list-item>
        </mu-list>
        <mu-card-text>
          <p v-if="!hasQuestions">
            {{$t('message.lessonQuestionsEmpty')}}
          </p>
          <mu-row>
            <mu-col width="100" desktop="60" tablet="70">
<!--              <mu-pagination-->
<!--                v-if="hasQuestions"-->
<!--                :total="data.total_questions"-->
<!--                :current="data.page"-->
<!--                :defaultPageSize="5"-->
<!--                :pageSize="query.per_page"-->
<!--                @pageChange="handlePageChange">-->
<!--              </mu-pagination>-->
            </mu-col>
            <mu-col width="100" desktop="40" tablet="30" align="right">
              <mu-raised-button backgroundColor="#3d8517" color="white" label="Ask a question"
                                @click.native="askQuestion"></mu-raised-button>
            </mu-col>
          </mu-row>
        </mu-card-text>
      </div>
  </mu-card>
</template>
<script>

  import DiscussionApi from '../../../api/Discussion'

  import CreateQuestion from "../../Questions/CreateQuestion/CreateQuestion";

  export default {
    components: {
      CreateQuestion,
    },
    name: "questions-panel",
    props: {
      courseId: {
        type: Number
      }
    },
    data() {
      var self = this;
      return {
        query: {
          page: 1,
          per_page: 5,
          type: "MOST_RECENT",
          course_id: self.courseId,
        },
        paginator: [],
        data: {},
        changeData: false,
      }
    },
    mounted() {
      let self = this;
      DiscussionApi.getDiscussionQuestions(self.query)
        .then(function (response) {
          self.data = response.data;
        })
    },
    computed: {
      hasQuestions() {
        let self = this;
        if (!_.has(self.data, 'questions')) {
          return false

        }
        return self.data.questions.length > 0;
      },
    },
    methods: {
      askQuestion() {
        let self = this;
        self.$router.push({
          name: 'Ask a question'
        })
      },
      handlePageChange(page) {
        let self = this;
        self.loadData();
      },
      loadData(page) {
        let self = this;
        DiscussionApi.getDiscussionQuestions(self.query)
          .then(function (response) {
            self.data = response.data;
          })
      },
      goToQuestion(id) {
        let self = this;
        self.$router.push({
          path: '/questions/thread/' + id,
          query: {
            page: 1,
            per_page: 10
          }
        })
      },
      upperTwoInitials(displayName) {
        if (displayName.indexOf(' ') !== -1) {
          const splitString = displayName.split(' ');
          return splitString[0].charAt(0).toUpperCase() + splitString[1].charAt(0).toUpperCase();
        }
        return displayName.charAt(0).toUpperCase();
      },
      formatDate(date) {
        return moment.utc(date).fromNow()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// QuestionsPanel.vue?43b88cf4